export default {
  typeOptions (state) {
    return state.types.map(type => ({ label: type.name, value: type.id }))
  },
  placeOptions (state) {
    return state.places.map(place => ({ label: place.name, value: place.id }))
  },
  promoterOptions (state) {
    return state.promoters.map(user => ({
      label: `${user.first_name || ''} ${user.last_name || ''}`.trim(),
      value: user.id
    }))
  }
}
